import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectSubscriptionsInStore,
  selectSubscriptionsPageLoading,
  selectSubscriptionsShowInitWaitingMessage,
} from '../_selectors/subscription.selectors';

export class SubscriptionsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectSubscriptionsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectSubscriptionsShowInitWaitingMessage));

    this.store.pipe(select(selectSubscriptionsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
